var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newLabel"},[_c('aj-text',{attrs:{"tag":"span","body-low":"","bold":""}},[_vm._v(" NEW ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }